const FIELDS_LIST = [
  'id',
  'inventoryId',
  'pono',
  'serialNumber',
  'receivedByUserId',
  'receivedDate',
  'EnteredByUserId',
  'poItemNo',
  'sono',
  'soItemNo',
  'invoiceNo',
  'invoiceItemNo',
  'rmanNo',
  'rmaItemNo',
  'rtvNo',
  'rtvItemNo',
  'allocated',
  'quarantine',
  'receivingItemNo',
  'location',
  'comment',
  'soScheduleItemNo',
  'serialNumber2'];

export class InventorySerialNumberDto {
  constructor(data = {}) {
    FIELDS_LIST
      .forEach((key) => this[key] = data[key] || null);
  }
}

export default InventorySerialNumberDto;
